<div #someelementone>
	<img src="/assets/img/logo-manpower.png" class="logo-contactanos">
	<h3>Contáctanos</h3>
	<p class="titulo">Contacta a uno de nuestros consultores <br>para que te asesore sobre la mejor solución <br>para tu negocio.</p>
	<br>
	<form [formGroup]="contacto" (ngSubmit)="onSubmit()">
		<div class="form-group">
			<label for="nombre">Nombre*</label>
			<input type="text" class="form-control form-control-sm" id="nombre" formControlName="nombre" [(ngModel)]="nombre">
			<div *ngIf="submitted && contacto.controls['nombre'].errors?.['required']">
		      <div class="invalid">* Campo requerido</div>
		    </div>
		</div>
		<div class="form-group">
			<label for="Apellido">Apellido*</label>
			<input type="text" class="form-control form-control-sm" id="Apellido" formControlName="apellido" [(ngModel)]="apellido">
			<div *ngIf="submitted && contacto.controls['apellido'].errors?.['required']">
		      <div class="invalid">* Campo requerido</div>
		    </div>
		</div>
		<div class="form-group">
			<label for="Empresa">Empresa*</label>
			<input type="text" class="form-control form-control-sm" id="Empresa" formControlName="empresa" [(ngModel)]="empresa">
			<div *ngIf="submitted && contacto.controls['empresa'].errors?.['required']">
		      <div class="invalid">* Campo requerido</div>
		    </div>
		</div>
		<div class="form-group">
			<label for="Cargo">Cargo</label>
			<input type="text" class="form-control form-control-sm" id="Cargo" formControlName="cargo" [(ngModel)]="cargo">
		</div>
		<div class="form-group">
			<label for="Móvil">Móvil*</label>
			<input type="text" class="form-control form-control-sm" id="Móvil" formControlName="movil" [(ngModel)]="movil">
			<div *ngIf="submitted && contacto.controls['movil'].errors?.['required']">
		      <div class="invalid">* Campo requerido</div>
		    </div>
		</div>
		<div class="form-group">
			<label for="Correo">Correo</label>
			<input type="text" class="form-control form-control-sm" id="Correo" formControlName="correo" [(ngModel)]="correo">
		</div>
		<div class="form-group">
			<label for="Ubicación">Ubicación</label>
			<input type="text" class="form-control form-control-sm" id="Ubicación" formControlName="ubicacion" [(ngModel)]="ubicacion">
		</div>
		<div class="form-group">
			<label for="cotiza">Cotiza tu servicio</label>
			<select class="form-select form-select-sm form-control-sm" id="cotiza" formControlName="cotiza" [(ngModel)]="cotiza">
				<option>Seleccionar</option>
				<option>Headhunting</option>
				<option>Logística</option>
				<option>Promotoría</option>
				<option>Administración</option>
				<option>Reclutamiento</option>
				<option>Payrolling</option>
				<option>Capacitaciones</option>
				<option>Evaluaciones y Estudios</option>
				<option>HR BPO</option>
				<option>MyPath</option>
				<option>Búsqueda de Empleo </option>
				<option>Dudas y Aclaraciones </option>
			</select>
		</div>
		<div class="form-group">
			<label for="descripcion">Detalles de tu solicitud</label>
			<textarea class="form-control form-control-sm" id="descripcion" formControlName="descripcion" [(ngModel)]="descripcion" placeholder="Escribe aquí" rows="7"></textarea>
		</div>
		<p class="text-size-0_7rem">Para poder proporcionarte el contenido solicitado, <br>necesitamos almacenar y procesar tus datos personales. <br>Si das tu consentimiento para que almacenemos tus <br>datos personales para este fin, marca la casilla de <br>verificación a continuación.</p>

		<div class="row">
			<div class="col-1">
				<input type="checkbox" id="check-condiciones" name="check-condiciones">
			</div>

			<div class="col-10">
				<p class="no-margin text-size-0_7rem" for="check-condiciones">
					Acepto que Manpower, S.A. de C.V. y sus empresas <br>filiales y/o subsidiarias almacenen y procesen mis <br>datos personales.
				</p>

				<br>

				<p class="no-margin text-size-0_7rem">
					*Puedes darte de baja de estas comunicaciones <br>
					en cualquier momento. Para obtener más información <br>sobre cómo cancelar la suscripción, nuestras prácticas <br>de privacidad y cómo nos comprometemos a proteger <br>y respetar tu privacidad, consulta nuestra Política de <br>privacidad.
				</p>
			</div>
		</div>
		<button class="btn btn-primary margin-top-30">Enviar</button>
	</form>

	<div *ngIf="mensaje!=''" class="margin-top-30">
		<div class="alert alert-success text-center">
			{{mensaje}}
		</div>
	</div>
</div>